import React from 'react'

import i18n from 'i18n-literally'

import { Box } from '@mui/material'

import {
  Field,
  Form,
  Formik,
  useFormikContext,
} from 'formik'

import createLogger from '~/src/Lib/Logging'
import Button from '~/src/UI/Shared/Button'
import { FormikTextField } from '~/src/UI/Shared/Form/TextField'
import T from '~/src/UI/Shared/Typography'

import { getPersonalDataInitialValues, getPersonalDataValidationSchema } from './utils'

const displayName = 'PersonalDataForm'
const logger = createLogger(displayName)

const PersonalData = ({
  activeStep,
  handleGoBackStep,
  handleNextStep
}) => {
  const { isValid } = useFormikContext()
  return (
    <Form>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gap="1rem"
      >
        <T.H2>{i18n`Your Info`}</T.H2>
        <T>{i18n`Please fill in some personal details`}</T>
        <Box width={300} display="flex" flexDirection="column" gap="3rem">
          <Box display="flex" flexDirection="column" gap="1ch">
            <Field
              fullWidth
              required
              name="firstName"
              label={i18n`First name`}
              component={FormikTextField}
            />
            <Field
              fullWidth
              required
              name="lastName"
              label={i18n`Last name`}
              component={FormikTextField}
            />
            <Field
              fullWidth
              required
              name="email"
              label={i18n`Email`}
              component={FormikTextField}
            />
            <Field
              fullWidth
              required
              name="retypeEmail"
              label={i18n`Retype email`}
              component={FormikTextField}
            />
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Button
              disabled={activeStep === 0}
              onClick={handleGoBackStep}
              variant="text"
            >
              {i18n`Go back`}
            </Button>
            <Button
              type="submit"
              sx={{ padding: '0 3rem' }}
              disabled={!isValid}
              onClick={handleNextStep}
            >
              {i18n`Next`}
            </Button>
          </Box>
        </Box>
      </Box>
    </Form>
  )
}

const Connected = props => {
  // TODO: get token and use bundle that hits the correct endpoint
  // const {} = useConnect()
  const initialValues = getPersonalDataInitialValues()
  const validationSchema = getPersonalDataValidationSchema()
  const handleSubmit = () => {}

  return (
    <Formik
      validateOnMount
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <PersonalData {...props} />
    </Formik>
  )
}

const Memoized = React.memo(Connected)
export default Memoized
